module.exports = "<div>\r\n  <div class=\"header\">\r\n    <h3> <span class=\"left\" on-click=\"back\"><i></i>返回</span></h3>\r\n  </div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/homeHeader.html
// module id = 357
// module chunks = 1